export default "__VITE_ASSET__BUjZhraF__"